// Class: starling.filters.CompositeMode

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;

// Constructor

var CompositeMode = function(){}

// Meta

CompositeMode.__name__ = "starling.filters.CompositeMode";
CompositeMode.__isInterface__ = false;
CompositeMode.prototype = {
	
};
CompositeMode.prototype.__class__ = CompositeMode.prototype.constructor = $hxClasses["starling.filters.CompositeMode"] = CompositeMode;

// Init



// Statics

CompositeMode.getIndex = function(mode) {
	return CompositeMode.allModes.indexOf(mode);
}
CompositeMode.allModes = ["normal","inside","insideKnockout","outside","outsideKnockout"]
CompositeMode.NORMAL = "normal"
CompositeMode.INSIDE = "inside"
CompositeMode.OUTSIDE = "outside"
CompositeMode.INSIDE_KNOCKOUT = "insideKnockout"
CompositeMode.OUTSIDE_KNOCKOUT = "outsideKnockout"

// Export

exports.default = CompositeMode;